(function () {
  const queue = [];

  function flushQueue() {
    if (!window.posthog || typeof posthog.capture !== 'function') return false;
    while (queue.length) {
      const { event, properties } = queue.shift();
      posthog.capture(event, properties);
    }
    return true;
  }

  function liljaCapture(event, properties) {
    if (window.posthog && typeof posthog.capture === 'function') {
      flushQueue();
      posthog.capture(event, properties);
      return;
    }
    queue.push({ event, properties });
  }

  function waitForPosthog(attempts) {
    if (flushQueue()) return;
    if (attempts >= 50) return;
    setTimeout(function () {
      waitForPosthog(attempts + 1);
    }, 100);
  }

  function captureCartViewed(surface) {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        liljaCapture('cart_viewed', {
          cart_total: cart.total_price / 100,
          cart_item_count: cart.item_count,
          cart_surface: surface,
          currency: cart.currency,
        });
      })
      .catch(function () {
        liljaCapture('cart_viewed', { cart_surface: surface });
      });
  }

  function initProductClickTracking() {
    document.addEventListener('click', function (event) {
      const link = event.target.closest('[data-lilja-product-id]');
      if (!link || !link.href || !link.href.includes('/products/')) return;

      const wrapper = link.closest('[data-lilja-list-id]');
      const properties = {
        product_id: link.dataset.liljaProductId,
        product_title: link.dataset.liljaProductTitle,
      };

      if (link.dataset.liljaPosition) {
        properties.position = Number(link.dataset.liljaPosition);
      }

      const listId = link.dataset.liljaListId || (wrapper && wrapper.dataset.liljaListId);
      const listName = link.dataset.liljaListName || (wrapper && wrapper.dataset.liljaListName);

      if (listId) properties.list_id = listId;
      if (listName) properties.list_name = listName;

      liljaCapture('product_clicked', properties);
    });
  }

  function initPageEvent() {
    const pageEventEl = document.getElementById('lilja-page-event');
    if (!pageEventEl) return;

    try {
      const data = JSON.parse(pageEventEl.textContent);
      if (data.event) {
        liljaCapture(data.event, data.properties || {});
      }
    } catch (error) {
      console.error('lilja-page-event parse error', error);
    }
  }

  window.liljaCapture = liljaCapture;
  window.liljaCaptureCartViewed = captureCartViewed;
  window.liljaFlushPosthogQueue = flushQueue;

  document.addEventListener('DOMContentLoaded', function () {
    initPageEvent();
    initProductClickTracking();
    waitForPosthog(0);
  });
})();
